module.exports = __webpack_public_path__ + "static/folk_hero-e7d88e2c2b418066e7fcec587215e0aa.jpg";